// src/api/shopify.ts
import api from "./client";

export async function getShopifyStatus() {
  const res = await api.get("/shopify/status");
  return res.data;
}

export async function startShopifyOAuth(shopDomain: string) {
  const res = await api.get("/shopify/connect", {
    params: { shop: shopDomain },
  });

  const data = res.data;

  if (!data?.auth_url) {
    throw new Error(data?.error || "Failed to start Shopify OAuth");
  }

  window.location.href = data.auth_url;
}

/**
 * Finalize Shopify OAuth after redirect back to SPA
 */
export async function finishShopifyOAuth(query: URLSearchParams) {
  const payload = {
    code: query.get("code"),
    hmac: query.get("hmac"),
    shop: query.get("shop"),
    state: query.get("state"),
    timestamp: query.get("timestamp"),
    host: query.get("host"),
  };

  const res = await api.post("/shopify/callback", payload);

  const data = res.data;
  return data;
}

export async function disconnectShopify() {
  const res = await api.post("/shopify/disconnect");
  return res.data;
}

/** 🧩 Manually sync Shopify catalog */
export async function syncShopifyCatalog() {
  const res = await api.post("/shopify/catalog_sync");
  return res.data;
}

/** 🧨 Permanently delete Shopify shop + catalog */
export async function deleteShopifyShop() {
  const res = await api.post("/shopify/delete_shop");
  return res.data;
}
